import { render, staticRenderFns } from "./RainJoin.vue?vue&type=template&id=63e4f13f&scoped=true"
import script from "./RainJoin.vue?vue&type=script&lang=js"
export * from "./RainJoin.vue?vue&type=script&lang=js"
import style0 from "./RainJoin.vue?vue&type=style&index=0&id=63e4f13f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e4f13f",
  null
  
)

export default component.exports